import { takeEvery, call, put } from 'redux-saga/effects';

import { CONFIRM_ACCOUNT, setLoginRedirection } from 'src/app/redux/actions/registration/confirmAccount';
import confirmApi from 'src/app/api/confirmApi';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import { transclusionShow } from 'src/app/redux/actions/transclusion';
import { loginConfirmedUser } from 'src/app/redux/actions/login/login';
import transclusionSaga from 'src/app/redux/sagas/transclusionSaga.json';


function* redirectUser() {
  yield put(setLoginRedirection(true));
  yield put(transclusionShow(transclusionSaga.activationTokenError));
}

const createConfirmationBody = () => {
  const activationToken = getWindowSearchParam('activationToken');
  const userId = getWindowSearchParam('userId');

  return { activationToken, userId };
};

function confirmAccount(request, prepareBody) {
  return function* confirmAccountGenerator() {
    const { activationToken, userId } = prepareBody();

    if (!(activationToken && userId)) {
      yield redirectUser();
      return;
    }

    const confirmationWithDispatchers = yield request({ activationToken, userId })
      .then(function* onSuccess() {

        return yield put(loginConfirmedUser());
      })
      .catch(function* onError() {
        yield redirectUser();
      });

      yield call(() => confirmationWithDispatchers);
  };
}

export default [
  takeEvery(CONFIRM_ACCOUNT, confirmAccount(confirmApi.confirmRequest, createConfirmationBody))
];
